import  {useSelector} from "react-redux";

const useRealTimeNotificationId = () => {
    const realTimeNotification = useSelector( (state) => state.realTimeNotification );
    return realTimeNotification && realTimeNotification.notificationId ? realTimeNotification.notificationId : null;
}

export { useRealTimeNotificationId }